import { jsxs as a, jsx as n } from "react/jsx-runtime";
import { Field as p, Switch as x, Label as d } from "@headlessui/react";
import { twMerge as e } from "tailwind-merge";
const k = ({
  switcherElement: s,
  selected: r,
  onChange: i,
  label: t,
  labelClassName: m,
  wrapperClassName: l,
  switcherClassName: f,
  disabled: o
}) => /* @__PURE__ */ a(
  p,
  {
    className: e(
      "relative flex flex-col gap-2 md:flex-row md:items-center",
      l
    ),
    children: [
      /* @__PURE__ */ n(
        x,
        {
          checked: r,
          disabled: o,
          onChange: i,
          onKeyDown: (c) => {
            c.key === "Enter" && !o && (c.preventDefault(), i(!r));
          },
          className: e("focus-ring inline-flex w-fit shrink-0 rounded-sm", f),
          children: s
        }
      ),
      t && /* @__PURE__ */ n(d, { className: e("cursor-pointer", m), children: t })
    ]
  }
);
export {
  k as BaseSwitcher
};
